module.exports = __webpack_public_path__ + "img/traits_3@2x.7637b6c9.png";